import { lazy } from 'react';

export const LoginPage = lazy(() => import('./ui/LoginPage/LoginPage'));
